"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MedicareM = void 0;
var _SVG = require("../SVG");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const MedicareM = props => /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  fill: "#13126C",
  fillRule: "evenodd",
  d: "m5.432 20.446 1.79-10.386 3.433 10.386H13.4L16.88 10.06l1.756 10.386h3L18.88 4h-3l-3.834 11.47L8.266 4H5.221L2.398 20.446h3.034Z",
  clipRule: "evenodd"
}));
exports.MedicareM = MedicareM;
MedicareM.displayName = "MedicareM";